import React, { useContext} from 'react'
import { useDispatch} from 'react-redux'
import { RadarPage } from './containers'
import {  DataContext } from './store/GlobalState'

export const WrapperRadarPage = props => {
  const {dispatch } = useContext(DataContext)
  const reduxDispatch = useDispatch()

    return (
       <RadarPage {...props} dispatch={dispatch} 
         reduxDispatch={reduxDispatch}
      />
    )
}
